import React from 'react';
import styles from './stats.module.css';

/**
 * Balão dos gráficos (Recharts `Tooltip content`): título do ponto e uma
 * linha por série, com a cor e o valor já formatado.
 *
 * `format(value, entry)`: formatação do valor; `title(label, payload)`: título;
 * `dim(entry)`: true para a série comparada (bolinha mais clara).
 * `footer(payload)`: linha extra de soma no fim ({ label, value } ou null).
 */
const ChartTooltip = ({ active, payload, label, format, title, dim, footer }) => {
  if (!active || !payload || payload.length === 0) return null;
  const rows = payload.filter((entry) => entry.value !== null && entry.value !== undefined);
  if (rows.length === 0) return null;
  const total = footer ? footer(payload) : null;

  return (
    <div className={styles.tooltip}>
      <span className={styles.tooltipTitle}>{title ? title(label, payload) : label}</span>
      {rows.map((entry) => (
        <div key={entry.dataKey ?? entry.name} className={styles.tooltipRow}>
          <span
            className={styles.dot}
            style={{ background: entry.payload?.color || entry.color, opacity: dim && dim(entry) ? 0.4 : 1 }}
          />
          <span>{entry.name}</span>
          <span className={styles.tooltipValue}>{format ? format(entry.value, entry) : entry.value}</span>
        </div>
      ))}
      {total && (
        <div className={`${styles.tooltipRow} ${styles.tooltipTotal}`}>
          <span>{total.label}</span>
          <span className={styles.tooltipValue}>{total.value}</span>
        </div>
      )}
    </div>
  );
};

export default ChartTooltip;
